import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main/main.component';

import { DataExchangeService } from 'src/app/shared/services/data-exchange.service';
import { CDSService } from 'src/app/shared/services/cds.service';
import { InterceptorService } from 'src/app/shared/services/auth/interceptor.service';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { TourMatMenuModule } from 'ngx-tour-md-menu';

@NgModule({
    imports: [
        CommonModule,
        MainRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        AngularFontAwesomeModule,
        TourMatMenuModule.forRoot()
    ],
    declarations: [
        MainComponent
    ],
    providers: [

        // DO NOT INCLUDE DataExchangeService ANYWHERE ELSE !!
        DataExchangeService,

        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        CDSService
    ]
})
export class MainModule { }
